import React, { useState, useEffect } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faDownload, faFilePdf, faFileWord } from "@fortawesome/free-solid-svg-icons";
import { getCandidateProfileById, view_resume } from "../../Api/apiService";
import "./ViewResume.css";
import Logo from "../../Images/NucleusTeq Logo.png";
import html2pdf from "html2pdf.js";
import { useSelector } from "react-redux";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";
import PizZip from "pizzip";

const ViewResume = (candidateId) => {
  const { userId } = useParams();
  const location = useLocation();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const role = useSelector((state) => state.auth);
  const queryParams = new URLSearchParams(location.search);
  const profileId = queryParams.get("profileId");

  const selectedRole = localStorage.getItem("selectedRole") || { selectedRole: "" };
 
  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      try {
        const response = await view_resume(userId);
        
        const selectedProfile = response.data.find((profile) => profile.id === parseInt(profileId));

        if (selectedProfile) {
          const email = JSON.parse(localStorage.getItem("auth"))?.email;
          setProfile({ ...selectedProfile, email });
        } else {
          setError("Profile not found");
        }
      } catch (error) {
        setError("Error fetching profile data.");
      } finally {
        setLoading(false);
      }
    };

    if (userId && profileId) {
      fetchProfile();
    }
  }, [userId, profileId]);

  const downloadPDF = () => {


    

    const element = document.getElementById("resume-content");
    const opt = {
      margin: [10, 0, 23, 0],
      filename: `${profile.profileName}_Resume.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2, scrollX: 0, scrollY: 0, useCORS: true },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { 
        mode: ["css", "legacy"],   // enforce CSS rules
        before: ".section-title",  // force new page before big headings if needed
      },
    };

    html2pdf().set(opt).from(element).save();
  };

   const previewPDF = () => {
      const element = document.getElementById("resume-content");
      // const opt = {
      //   margin: [10, 0, 23, 0],
      //   filename: `${profile?.profileName || "Employee"}_Resume.pdf`,
      //   image: { type: "jpeg", quality: 0.98 },
      //   html2canvas: { allowTaint: true,
      //     letterRendering: true,scale: 2, scrollX: 0, scrollY: 0, useCORS: true },
      //   jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      //   autoPaging: 'text',
      //   pagebreak: {
      //      mode: [ "css","legacy"], // Avoid breaking in the middle of elements
      //   },
      // };

      const opt = {
        margin: [10, 0, 23, 0],
        filename: `${profile.profileName}_Resume.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2, scrollX: 0, scrollY: 0, useCORS: true },
        jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
        pagebreak: { 
          mode: ["avoid-all", "css", "legacy"],
          avoid: ".resume-block",   // 🚀 keep each block together
        },
      };

    
      // Open the PDF in a new tab
      html2pdf().set(opt).from(element).toPdf().get("pdf").then((pdf) => {
        const pdfBlob = pdf.output("bloburl");
        window.open(pdfBlob, "_blank");
      });
    };
  
    const downloadWord = () => {
      fetch("/resume_template.docx") 
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to load the Word template file.");
          }
          return response.arrayBuffer();
        })
        .then((content) => {
          // Use PizZip to load the content
          const zip = new PizZip(content);
          const doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
          });
  
          // Replace placeholders in the template with dynamic data
          doc.render({
            name: profile?.profileName || "Employee",
            objective: profile?.objective || "N/A",
            professionalSummary: profile?.profileData?.professionalSummary || "N/A",
            technicalSkills: profile?.profileData?.technicalSkills || [],
            professionalExperience: profile?.profileData?.professionalExperience || [],
            education: profile?.profileData?.education || [],
            certificates: profile?.profileData?.certificates || [],
          });
  
          // Generate the Word document as a blob
          const blob = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
  
          console.log("Docxtemplater Data:", doc.getFullText());
  
          // Save the Word document
          saveAs(blob, `${profile?.profileName || "Employee"}_Resume.docx`);
        })
        .catch((error) => {
          console.error("Error loading or generating Word template:", error);
        });
        
    };

  const formatExperienceDetails = (details) => {
    const specialCharactersRegex = /^[^a-zA-Z0-9]/;
    return details?.split(".").map((sentence, index) => {
      let trimmedSentence = sentence.trim();
      if(specialCharactersRegex.test(trimmedSentence)) {
        trimmedSentence = trimmedSentence.replace(specialCharactersRegex, "");
      }
      return trimmedSentence ? (
        <li key={index}>
          {trimmedSentence}
          {trimmedSentence.endsWith(".") ? "" : "."}
        </li>
      ) : null;
    });
  };

  const formatDate = (date) => {
    if (!date) return "";

    if (date.toLowerCase() === "present" || date.toLowerCase() === "current" || date.toLowerCase() === "now" || date.toLowerCase() === "till date") {
      return "Present";
    }

    const monthYearRegex = /^([a-zA-Z]{3,9})['’]?(\d{2}|\d{4})$/; // Matches formats like "Jan'22" or "Jan22"
    const match = date.match(monthYearRegex);

  if (match) {
    const month = match[1]; // Extract the month (e.g., "Jan")
    const year = `20${match[2]}`; // Extract the year (e.g., "22" -> "2022")
    const monthIndex = new Date(`${month} 1, ${year}`).getMonth(); // Get the month index (0-11)
    const options = { year: "numeric", month: "2-digit" };
    return new Date(year,monthIndex, 1).toLocaleDateString("en-GB", options).replace(/\//g, "/");
  }

  const numericMonthYearRegex = /^(\d{1,2})\/(\d{4})$/;
  const numericMatch = date.match(numericMonthYearRegex);

  if (numericMatch) {
    const month = numericMatch[1]; // Extract the month
    const year = numericMatch[2]; // Extract the year
    const options = { year: "numeric", month: "2-digit" };
    return new Date(year, month - 1, 1).toLocaleDateString("en-GB", options).replace(/\//g, "/");
  }


  const isoDateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
  const isoMatch = date.match(isoDateRegex);
  if (isoMatch) {
    const year = parseInt(isoMatch[1], 10);
    const month = parseInt(isoMatch[2], 10) - 1;
    const day = parseInt(isoMatch[3], 10);
    return new Date(year, month, day).toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });

    
  }

  const usDateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
  const usMatch = date.match(usDateRegex);
  if (usMatch) {
    const month = parseInt(usMatch[1], 10) - 1;
    const day = parseInt(usMatch[2], 10);
    const year = parseInt(usMatch[3], 10);
    return new Date(year, month, day).toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  }

  const euDateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
  const euMatch = date.match(euDateRegex);
  if (euMatch) {
    const day = parseInt(euMatch[1], 10);
    const month = parseInt(euMatch[2], 10) - 1;
    const year = parseInt(euMatch[3], 10);
    return new Date(year, month, day).toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  }

  // Regex for "Month YYYY"
  const fullMonthYearRegex = /^([a-zA-Z]{3,9}) (\d{4})$/;
  const fullMonthYearMatch = date.match(fullMonthYearRegex);
  if (fullMonthYearMatch) {
    const month = fullMonthYearMatch[1];
    const year = parseInt(fullMonthYearMatch[2], 10);
    const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
    return new Date(year, monthIndex, 1).toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short",
    });
  }

  

    // const options = { year: "numeric", month: "2-digit" };
    // return new Date(date).toLocaleDateString("en-GB", options).replace(/\//g, "/");
    return date; // Return the original date if no match is found
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!profile) return <div>No profile data available</div>;

  const sortedExperience = [...(profile.profileData?.professionalExperience || [])].sort(
    (a, b) => new Date(b.endDate) - new Date(a.endDate)
  );

  const sortedEducation = [...(profile.profileData?.education || [])].sort(
    (a, b) => new Date(b.duration.split(" - ")[1]) - new Date(a.duration.split(" - ")[1])
  );





return (
  <>
    <div className="btn-container">
      <Link
        to={
          role.role === "ROLE_EMPLOYEE" ? "/Dashboard" : "/candidateResumeList"
        }
        className="icon-button"
        title="back"
      >
        <FontAwesomeIcon icon={faArrowLeft} />
      </Link>
      <button onClick={previewPDF} className="icon-button" title="preview pdf">
        <FontAwesomeIcon icon={faFilePdf} />
      </button>
      <button onClick={downloadWord} className="icon-button" title="download word">
        <FontAwesomeIcon icon={faFileWord} />
      </button>
      <button onClick={downloadPDF} className="icon-button" title="download pdf">
        <FontAwesomeIcon icon={faDownload} />
      </button>
    </div>

    <hr />

    <div className="resume-container" id="resume-content">
      <div className="logo-container">
        <img src={Logo} alt="logo" className="logo" />
      </div>

      <div className="personal-info">
        <h1>
          {role.role === "ROLE_EMPLOYEE" ? role.name : profile.profileName}
        </h1>
      </div>

      {profile.objective && (
        <div className="sub-section element">
          <h2 className="section-title element">Objective</h2>
          <div className="resume-block">
            <p>{profile.objective}</p>
          </div>
        </div>
      )}

      {profile.profileData?.professionalSummary && (
        <div className="sub-section element">
          <h2 className="section-title element">Professional Summary</h2>
          <div className="resume-block">
            <p className="section-para element">
              {profile.profileData.professionalSummary}
            </p>
          </div>
        </div>
      )}

      {profile.profileData?.technicalSkills && (
        <>
          <h2 className="section-title element">Technical Skills</h2>

          {profile.profileData.technicalSkills.technology?.length > 0 && (
            <div className="sub-section element">
              <h3 className="sub-section-title element">Technology</h3>
              <ul className="bullet-section-tech element">
                {profile.profileData.technicalSkills.technology.map(
                  (tech, index) => (
                    <div key={index} className="resume-block">
                      <li>{tech}</li>
                    </div>
                  )
                )}
              </ul>
            </div>
          )}

          {profile.profileData.technicalSkills.programming?.length > 0 && (
            <div className="sub-section element">
              <h3 className="sub-section-title element">Programming</h3>
              <ul className="bullet-section-tech element">
                {profile.profileData.technicalSkills.programming.map(
                  (prog, index) => (
                    <div key={index} className="resume-block">
                      <li>{prog}</li>
                    </div>
                  )
                )}
              </ul>
            </div>
          )}

          {profile.profileData.technicalSkills.tools?.length > 0 && (
            <div className="sub-section element">
              <h3 className="sub-section-title element">Tools</h3>
              <ul className="bullet-section-tech element">
                {profile.profileData.technicalSkills.tools.map(
                  (tool, index) => (
                    <div key={index} className="resume-block">
                      <li>{tool}</li>
                    </div>
                  )
                )}
              </ul>
            </div>
          )}
        </>
      )}

      {sortedExperience.length > 0 && (
        <div className="sub-section element">
          <h2 className="section-title element">Professional Experience</h2>
          {sortedExperience.map((experience, index) => (
            <div key={index} className="professional-experience element">
              <h3 className="experience-heading element">
                {experience.jobTitle} at {experience.companyName}
                <span className="experience-dates element">
                  ({experience.startDate} - {experience.endDate})
                </span>
              </h3>

              <div className="resume-block">
                <p>
                  <strong>Project:</strong> {experience.projectName}
                </p>
              </div>

              <div className="resume-block">
                <p>
                  <strong>Technologies Used:</strong> {experience.techStack}
                </p>
              </div>

              <ul className="bullet-section element">
                {formatExperienceDetails(experience.details).map((point, idx) => (
                  <div key={idx} className="resume-block">
                    <li>{point}</li>
                  </div>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}

      {sortedEducation.length > 0 && (
        <div className="sub-section element">
          <h2 className="section-title element">Education</h2>
          {sortedEducation.map((education, index) => (
            <div key={index} className="education element">
              <h3 className="experience-heading element">
                {education.course} from {education.collegeName}
              </h3>
              <div className="resume-block">
                <p className="element">
                  Duration:{" "}
                  {formatDate(education.duration.split(" - ")[0])} -{" "}
                  {formatDate(education.duration.split(" - ")[1])}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </>
);

}
export default ViewResume;
